@if (appBusyState) {
<div class="app-busy">

    @switch (!!appBusyState['templatePortal']) {

    @case(true) {
    <ng-container [cdkPortalOutlet]="appBusyState['templatePortal']"></ng-container>
    }

    @case(false) {
    <p class="center">
        {{appBusyState['message'] || ''}}
    </p>
    }

    }
</div>
}
